import React from 'react'
import { capitalizeAll } from 'humanize-plus'
import { a } from 'utils/Helpers'

import ConversationPreview from './conversationPreview'

import BotFollowUp from '../botFollowUp'
import style from '../style.styl'

const NonMatchModalBody = ({
  answer: { response },
  question: { prompt },
  theme,
  targetCopy,
  shortTargetCopy,
  botFollowUpProps,
}) => {
  const defaultNonMatchResponse = (
    <span className="defaultNonmatch">Your non-matching follow-up will go here</span>
  )
  return (
    <div className={style.AnswerModalContent}>
      <div className="drift-form">
        <BotFollowUp {...botFollowUpProps} />
        <strong>Loop on Unsuccessful Capture</strong>
        <p>
          If the user’s answer doesn’t include a valid {targetCopy}, we’ll loop the response above.
        </p>
        <p>
          In {a(capitalizeAll(targetCopy))} Capture Question, a user’s answer must include{' '}
          {a(targetCopy)} in order to move on to the Next Step. If their answer doesn’t include{' '}
          {a(targetCopy)}, Driftbot will loop and ask the question again until they respond with{' '}
          {a(shortTargetCopy)}.{' '}
          {/*<a target="_blank" href="https://help.drift.com/campaigns/replies">
            Learn More
          </a>*/}
        </p>
      </div>
      <hr />
      <ConversationPreview
        prompt={prompt}
        nonMatchAnswer={response || defaultNonMatchResponse}
        backgroundColor={_.get(theme, 'backgroundColor', '2D88F3')}
        textColor={_.get(theme, 'textColor', 'FFFFF')}
      />
    </div>
  )
}

export default NonMatchModalBody



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalNonMatchBody/component.js